import { CategoryCreateDto, CategoryUpdateDto } from "../../../api";
import { CrudFormItemProps, CrudFormModal, nameof, RichtextEditor } from "digimuth-components/dist";

const formItems: CrudFormItemProps[] = [
    {
        name: nameof<CategoryCreateDto>("name"),
        label: "Nazwa",
        rules: [
            { required: true, message: 'To pole jest wymagane' }
        ],
    },
    {
        name: nameof<CategoryCreateDto>("description"),
        label: "Opis",
        rules: [
            { required: true, message: 'To pole jest wymagane' }
        ],
        children: <RichtextEditor
            toolbar={{
                options: ['inline', 'blockType', 'fontSize', 'list', 'history', "link"],
                inline: {
                    options: ['bold', 'italic', 'monospace']
                },
                list: {
                    option: ['unordered', 'ordered']
                },
                link: { inDropdown: true },
                history: { inDropdown: true }
            }}
        />
    },
];

export default function CategoryModalForm(props: CategoryModalProps) {
    return <CrudFormModal
        formProps={{ labelCol: { span: 3, offset: 0 } }}
        formItems={formItems}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues ?? { "description": process.env.REACT_APP_DEFAULT_CATEGORY_DESCRIPTION }}
        modalOkText={props.saveButtonTitle}
        modalTitle={props.modalTitle}
        forceRender={true}
        destroyOnClose={true}
        isModalVisible={props.isModalVisible}
        modalCancelText={"Anuluj"}
        width={1000}
    />;
}

interface CategoryModalProps {
    initialValues?: CategoryCreateDto | CategoryUpdateDto,
    isModalVisible: boolean,
    setModalVisibility: (isVisible: boolean) => any,
    onSubmit: (value: CategoryCreateDto | CategoryUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string;
}
